import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { getAllApiResources, getAllApplicationCategories, getAllPlatforms } from '../redux/actions/lookupData'
import ApiBuilder from '../services/ApiBuilder'
import AuthService from '../services/AuthService'

const AuthProvider = ({ children }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [processing, setProcessing] = useState(true)

  useEffect(() => {
    onInit()
    AuthService.instance.userManager.events.addUserSignedOut(() => history?.push('/logout-callback'))
  }, [])

  const onInit = async () => {
    setProcessing(true)
    const user = await AuthService.instance.getUser()

    if (user) {
      if (!user.expired && user.access_token) {
        // Setting access token
        ApiBuilder.setAccessTokenToHeader(user.access_token)

        // Initialize data
        initData()

      } else {
        // Redirecting to logout callback
        history?.push('/logout-callback')
      }
    }
    setProcessing(false)
  }

  const initData = () => {
    dispatch(getAllPlatforms())
    dispatch(getAllApplicationCategories())
    dispatch(getAllApiResources())
  }

  return (
    <Fragment>
      {!processing && children}
    </Fragment>
  )
}

export default AuthProvider